module.exports = __webpack_public_path__ + "static/media/4-hour.f90cae4b.png";